<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Image({
              label: 'Image',
              modelPath: [this, 'form', 'image'],
              required: true,
              onlyShowNormalCrop: true,
              onlyShowShortCrop: true,
              defaultThumbnail: !this.form.use_crop,
              specificThumbnail: this.specificThumbnail
            }),
            new fields.Input({
              label: 'Caption',
              multilingual: true,
              modelPath: [this, 'form', 'caption']
            }),
            new fields.Switch({
              label: 'No margins',
              modelPath: [this, 'form', 'no_margins']
            }),
            new fields.Select({
              label: 'Image type',
              modelPath: [this, 'form', 'image_type'],
              options: [
                { label: 'Large', value: 'normal' },
                { label: 'Short', value: 'short' },
                { label: 'Narrow', value: 'narrow' },
                { label: 'Vertical', value: 'vertical' }
              ]
            }),
            new fields.Switch({
              label: 'Use cropping',
              modelPath: [this, 'form', 'use_crop']
            })
          ]
        }
      ]
    },
    specificThumbnail() {
      if (this.form.image_type === 'narrow') {
        return 'normal'
      }
      return this.form.image_type
    }
  }
}
</script>
